export default __webpack_public_path__ + "static/media/keuangan_white.a6427f8c.svg";